const quickStats = [
  { value: '12+', label: '示例片单条目' },
  { value: '4 端', label: '手机 / 平板 / 电脑 / 电视' },
  { value: '5 步', label: '完整观看流程' },
];

const quickTags = ['在线观看', '免费观影', '高清播放', '手机版', '网页入口', '网址'];

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden bg-background-50">
      <div className="absolute -top-24 -left-24 w-[420px] h-[420px] rounded-full bg-primary-200/40 blur-3xl" />
      <div className="absolute top-40 -right-20 w-[360px] h-[360px] rounded-full bg-accent-200/35 blur-3xl" />

      <div className="relative w-full px-4 md:px-8 py-12 md:py-20 flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
        <div className="w-full lg:w-[58%] flex flex-col items-start">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-900 text-xs md:text-sm font-medium">
            <i className="ri-live-line" />
            在线观影入口信息整理 · 持续更新浏览方向
          </span>

          <h1 className="mt-5 font-heading font-black text-foreground-950 text-3xl md:text-5xl lg:text-[52px] leading-[1.15] text-balance">
            九七电影院：把在线观影入口
            <span className="text-primary-600"> 一次讲清楚</span>
          </h1>

          <p className="mt-5 text-foreground-700 text-base md:text-lg leading-relaxed max-w-2xl">
            本站围绕「九七电影院」这一搜索方向，整理在线观看、免费观影、高清播放、手机版、网页入口与网址等相关内容。
            你可以在同一页里了解入口怎么用、不同设备怎么看、画质怎么选，以及常见问题的说明，不必再来回翻找零散信息。
          </p>

          <div className="mt-7 flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto">
            <a
              href="#catalog"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-play-circle-line text-lg" />
              浏览精选片单
            </a>
            <a
              href="#guide"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-300/80 bg-background-50 text-foreground-900 text-sm md:text-base font-medium hover:bg-background-100 hover:border-primary-300 transition-colors whitespace-nowrap"
            >
              <i className="ri-route-line text-lg" />
              查看观看指南
            </a>
          </div>

          <div className="mt-7 flex flex-wrap gap-2">
            {quickTags.map((tag) => (
              <span
                key={tag}
                className="px-3 py-1.5 rounded-full bg-background-100 border border-background-200/80 text-foreground-700 text-xs md:text-sm"
              >
                {tag}
              </span>
            ))}
          </div>

          <div className="mt-8 w-full grid grid-cols-3 gap-3 md:gap-5 max-w-xl">
            {quickStats.map((stat) => (
              <div key={stat.label} className="px-3 py-3 md:px-4 md:py-4 rounded-lg bg-background-100/80 border border-background-200/70">
                <div className="font-heading font-bold text-xl md:text-2xl text-primary-700">{stat.value}</div>
                <div className="mt-1 text-[11px] md:text-xs text-foreground-600 leading-snug">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="w-full lg:w-[42%] relative">
          <div className="relative mx-auto max-w-sm lg:max-w-none">
            <div className="w-full aspect-[4/5] rounded-2xl overflow-hidden border border-background-200/80">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20artistic%20illustration%20of%20a%20cozy%20home%20cinema%20scene%20with%20warm%20amber%20lamp%20glow%2C%20film%20strip%20and%20projector%20light%20beams%2C%20abstract%20minimal%20style%2C%20cream%20and%20golden%20palette%2C%20soft%20shadows%2C%20refined%20editorial%20mood%2C%20no%20text&width=900&height=1125&seq=cinema-hero-main&orientation=portrait"
                alt="暖色调的家庭观影场景插画，象征在线观影入口与高清播放氛围"
                className="w-full h-full object-top object-cover"
              />
            </div>

            <div className="absolute -bottom-5 -left-4 md:-left-6 w-40 md:w-48 rounded-xl bg-background-50 border border-background-200/80 px-4 py-3 animate-float">
              <div className="flex items-center gap-2 text-accent-600">
                <i className="ri-hd-line text-lg" />
                <span className="text-xs font-medium text-foreground-700">高清播放</span>
              </div>
              <p className="mt-1.5 text-[11px] text-foreground-600 leading-snug">
                网络稳定时画面细节更清楚
              </p>
            </div>

            <div className="absolute -top-4 -right-3 w-32 md:w-36 rounded-xl bg-primary-500 text-background-50 px-4 py-3">
              <div className="flex items-center gap-2">
                <i className="ri-smartphone-line text-lg" />
                <span className="text-xs font-medium">手机版</span>
              </div>
              <p className="mt-1 text-[11px] text-primary-50 leading-snug">竖屏排版已适配</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}